import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

const Footer = () => {
  return (
    <footer className="text-dark footer-body py-3 border-top">
      <Container>
        <Row className="d-flex justify-content-between align-items-center">
          <Col md={6} className="m-0 p-0 mb-md-0 ">
            <p className='m-0 p-0'>Copyright &copy; {new Date().getFullYear()} Datara, All Rights Reserved.</p>
          </Col>
          <Col md={6} className="text-md-end">
            <a href="#" className="text-dark me-3 text-decoration-none">Privacy Policy</a>
            <a href="#" className="text-dark text-decoration-none">Terms of Service</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
